/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Table, Input, Button, Col, Label, Row } from 'reactstrap';
import {AppContext} from '../AppContext';
import { css } from '@emotion/react';
import { RingLoader } from 'react-spinners'
import InputNumber from 'rc-input-number';

class ChatInterface extends React.Component
{
  componentDidMount()
  {
/*    let textVectors = 0, imageVectors = 0, multiModalVectors = 0;
    let searchType = null;
    for (let x = 0; x < this.props.selectedObjects.length; x++)
    {
      switch (this.props.selectedObjects[x].vectorModality)
      {
        case 'text':
          textVectors++;
          searchType = 'Text Vector Search';
          break;

        case 'image':
          imageVectors++;
          searchType = 'Image Vector Search';
          break;
        
        case 'multiModalSearch':
          multiModalVectors++;
          searchType = 'MultiModal Vector Search';
          break;

        default:
          break;
      }
    }

    let len = this.props.selectedObjects.length;
    if ((textVectors && textVectors != len) || (imageVectors && imageVectors != len) || (multiModalVectors && multiModalVectors != len))
      this.context.postNotification('error', 'Searching multiple vector types not supported.');
    else
      this.setState({searchType, chatDisabled: false}); */
  }

  constructor(props)
  {
    super();

    this.state =
    {
      mmChatbotPrompt: '',
      mmRagResult: [],
      mmChatDisabled: false,
      spinnerIsSpinning: false,
      mmTopK: 5,
      useBlobVectorIndex: true,
      accuracy: 95
    }

    this.submitPrompt = this.submitPrompt.bind(this);
    this.setMultiModalChatbotPrompt = this.setMultiModalChatbotPrompt.bind(this);
    this.setMultiModalTopK = this.setMultiModalTopK.bind(this);
    this.toggleUseIndex = this.toggleUseIndex.bind(this);
    this.setAccuracy = this.setAccuracy.bind(this);
  }

  render()
  {
    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;

    return(
      <div>
        <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
          <RingLoader
            css={override}
            size={75}
            color={'#4A90E2'}
            loading={this.state.spinnerIsSpinning}
          />          
        </div>
        { null !== this.props.objectNames &&
          <Row style={{paddingTop: '10px'}}>
            <Col sm='2'>
              <Row>
                <Label>Selected Objects</Label>
              </Row>
            </Col>
            <Col>
              <Row><Input value={this.props.objectNames} disabled={true}></Input></Row>
            </Col>
          </Row>
        }
        <Row style={{paddingTop: "10px"}}>
          <Col sm='2'>
            <Row>
              <Label>MultiModal Query</Label>
            </Row>
          </Col>
          <Col>
            <Row>
              <Input type="textarea" style={{height: "150px"}} id="chatbotPrompt" value={this.state.mmChatbotPrompt} onChange={this.setMultiModalChatbotPrompt} 
                placeholder={'Type a prompt for the RAG Server / Chatbot...'} autoFocus />
            </Row>
            <Row style={{paddingTop: "10Px"}}>
              <Col sm='2'>
                <Label title="The number of hits to send upstream to the LLLM - from 5 to 15">RAG Response Limit</Label>
              </Col>
              <Col>
                <InputNumber style={{ width: 100 }} id='mmTopK' min={1} max={15}
                  onChange={this.setMultiModalTopK} value={this.state.mmTopK} />
              </Col>
            </Row>
            <Row style={{paddingTop: '10px'}}>
              <Col sm='2'><Label>Use Vector Index</Label></Col>
              <Col>
                <Input type="checkbox" id="useBlobVectorIndex" name="useBlobVectorIndex" onChange={this.toggleUseIndex}
                checked={(this.state.useBlobVectorIndex ? 'checked' : '')} style={{marginLeft: 0, marginTop: '0.7rem'}}
                title="Check this box to use the vector index (if any) for this search"/>
              </Col>
            </Row>
            <Row style={{paddingTop: "10Px"}}>
              <Col sm='2'>
                <Label title="The accuracy setting for a vector index search">Indexed Search Accuracy</Label>
              </Col>
              <Col>
                <InputNumber style={{ width: 100 }} id='accuracy' min={1} max={100}
                  onChange={this.setAccuracy} value={this.state.accuracy} />
              </Col>
            </Row>
            <Row style={{paddingTop: "10px"}}>
              <Col sm='2'>
                <Button disabled={this.state.mmChatDisabled} onClick={this.submitPrompt.bind(this, 'multiModal')} color="primary">Submit Prompt</Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm='2'>
            <Row>
              <Label>MultiModal Chatbot Response</Label>
            </Row>
          </Col>
          <Col sm='10'>
            <Row>
              <Table>
                <tbody>
                  { this.state.mmRagResult.map((ragResult, index) =>
                  (
                    <div>
                      <tr><td><Row><Col>{ragResult.objectName}</Col><Col>{ragResult.score}</Col></Row></td></tr>
                      <tr><td><img style={{height: '400px', maxWidth: 'auto', paddingTop: '10px', paddingBottom: '10px', marginLeft: 'auto', marginRight: 'auto', display: 'block'}} 
                        src={ragResult.weblink}  alt="similar object" />
                      </td></tr>
                    </div>
                  ))}
                </tbody>
              </Table>                  
            </Row>
          </Col>
        </Row>
      </div>        
    )
  }

  setAccuracy(valueAsNumber)
  {
    this.setState({accuracy: valueAsNumber});
  }

  setMultiModalChatbotPrompt(event)
  {
    let mmChatDisabled = event.target.value.length > 5 ? false : true;
    this.setState({mmChatbotPrompt: event.target.value, mmChatDisabled});
  }

  setMultiModalTopK(valueAsNumber, valueAsString, input)
  {
    this.setState({mmTopK: valueAsNumber});
  }

  async submitPrompt(searchType)
  {
    let bodyData = {};
    let selectedObjectIds = [];
    for (let x = 0; x < this.props.selectedObjects.length; x++) selectedObjectIds.push(this.props.selectedObjects[x].objectId);

    let selectedKeywordsAndValues = [];
    if (undefined !== this.props.filterData)
    {
      if (undefined !== this.props.filterData[0].queryKeyword)
      {
        for (let y = 0; y < this.props.filterData.length; y++)
        {
          let selectedKeywordAndValue = {keywordId: null, valueId: null, operator: this.props.filterData[y].operator.value};
          if (null !== this.props.filterData[y].queryKeyword)
          {
            selectedKeywordAndValue.keywordId = this.props.filterData[y].queryKeyword.keywordId;
            if (null !== this.props.filterData[y].queryValue) selectedKeywordAndValue.valueId = this.props.filterData[y].queryValue.valueId;
            selectedKeywordsAndValues[selectedKeywordsAndValues.length] = selectedKeywordAndValue;
          } 
        }
      }
    }

    let objectTypeIds = [];

    for (let x = 0; x < this.props.objectTypePickerData.length; x++)
    {
      if (this.props.objectTypePickerData[x].selected && x)   // Including test for x filters out the first entry which corresponds to 'all' data types.
        objectTypeIds[objectTypeIds.length] = this.props.objectTypePickerData[x].objectTypeId;
    }

    bodyData.objectTypeIds = objectTypeIds;
    bodyData.viewType = this.props.viewType;
    bodyData.userPrompt = this.state.mmChatbotPrompt;
    bodyData.topK = this.state.mmTopK;
    bodyData.useVectorIndex = this.state.useBlobVectorIndex ? 'Y' : 'N';
    bodyData.selectedObjectIds = selectedObjectIds;
    bodyData.selectedKeywordsAndValues = selectedKeywordsAndValues;
    bodyData.accuracy = this.state.accuracy;
    bodyData.vectorModality = 'image';

    if (undefined !== this.props.matchAnyOrAll) bodyData.matchAnyOrAll = this.props.matchAnyOrAll;

    this.setState({spinnerIsSpinning: true});
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'multiModalSearch', bodyData);
    this.setState({spinnerIsSpinning: false});
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Unable to get RAG server response');
    this.setState({mmRagResult: result.jsonData.ragResult});
  }

  toggleUseIndex()
  {
    this.setState({useBlobVectorIndex: !this.state.useBlobVectorIndex});
  }
}

ChatInterface.contextType = AppContext;

export default ChatInterface

/*

          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === 1 })} onClick={() => { this.toggleTab(1); }} >
              Image Search
            </NavLink>
          </NavItem>

          <TabPane tabId={1}>
            <Row style={{paddingTop: "10px"}}>
              <Col sm='2'>
                <Row>
                  <Label>Image Chatbot Prompt</Label>
                </Row>
              </Col>
              <Col>
                <Row>
                  <Input type="textarea" style={{height: "150px"}} id="imageChatbotPrompt" value={this.state.imageChatbotPrompt} onChange={this.setImageChatbotPrompt} 
                    placeholder={'Type a prompt for the RAG Server / Chatbot...'} autoFocus />
                </Row>
                <Row style={{paddingTop: "10Px"}}>
                  <Col sm='2'>
                    <Label title="The number of hits to send upstream to the LLLM - from 5 to 15">RAG Response Limit</Label>
                  </Col>
                  <Col>
                    <InputNumber style={{ width: 100 }} id='imageTopK' min={5} max={15}
                      onChange={this.setImageTopK} value={this.state.imageTopK} />
                  </Col>
                </Row>
                <Row style={{paddingTop: "10px"}}>
                  <Col sm='2'>
                    <Button disabled={this.state.imageChatDisabled} onClick={this.submitPrompt.bind(this, 'image')} color="primary">Submit Prompt</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row style={{paddingTop: "10px"}}>
              <Col sm='2'>
                <Row>
                  <Label>Image Chatbot Response</Label>
                </Row>
              </Col>
              <Col>
                <Row>
                  <Input type="textarea" style={{height: "300px"}} id="chatbotResponse" value={this.state.chatbotResponse} disabled={true} />
                </Row>
              </Col>
            </Row>
          </TabPane>
*/